import dayjs from 'dayjs';

// Helper function to get start of day
const startOfDay = (date) => {
    return dayjs(date).startOf('day');
};

// Helper function to get end of day
const endOfDay = (date) => {
    return dayjs(date).endOf('day');
};

export const DATE_PRESETS = [
    {
        key: 'today',
        label: 'Today',
        range: () => [
            startOfDay(new Date()),
            endOfDay(new Date())
        ]
    },
    {
        key: 'yesterday',
        label: 'Yesterday',
        range: () => [
            startOfDay(dayjs().subtract(1, 'day')),
            endOfDay(dayjs().subtract(1, 'day'))
        ]
    },
    {
        key: 'last7days',
        label: 'Last 7 Days',
        range: () => [
            startOfDay(dayjs().subtract(6, 'day')),
            endOfDay(new Date())
        ]
    },
    {
        key: 'last30days',
        label: 'Last 30 Days',
        range: () => [
            startOfDay(dayjs().subtract(29, 'day')),
            endOfDay(new Date())
        ]
    },
    {
        key: 'thisWeek',
        label: 'This Week',
        range: () => [
            startOfDay(dayjs().startOf('week')),
            endOfDay(new Date())
        ]
    },
    {
        key: 'lastWeek',
        label: 'Last Week',
        range: () => [
            startOfDay(dayjs().subtract(1, 'week').startOf('week')),
            endOfDay(dayjs().subtract(1, 'week').endOf('week'))
        ]
    },
    {
        key: 'thisMonth',
        label: 'This Month',
        range: () => [
            startOfDay(dayjs().startOf('month')),
            endOfDay(new Date())
        ]
    },
    {
        key: 'lastMonth',
        label: 'Last Month',
        range: () => [
            startOfDay(dayjs().subtract(1, 'month').startOf('month')),
            endOfDay(dayjs().subtract(1, 'month').endOf('month'))
        ]
    }
];

// Function to apply a preset and return a date range object
export const applyPreset = (presetKey) => {
    const preset = DATE_PRESETS.find(p => p.key === presetKey);

    if (!preset) {
        return null;
    }

    const [start, end] = preset.range();

    return {
        start: start.toDate(),
        end: end.toDate()
    };
};
